// import FuseSearch from '@fuse/core/FuseSearch';
import { ThemeProvider } from '@mui/material/styles';
// import FuseShortcuts from '@fuse/core/FuseShortcuts';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import NavigateBack from 'app/fuse-layouts/shared-components/NavigateBack';
import CallSupport from 'app/fuse-layouts/shared-components/CallSupport';
import NavigationHelp from 'app/fuse-layouts/shared-components/NavigationHelp';
// import QuickPanelToggleButton from 'app/fuse-layouts/shared-components/quickPanel/QuickPanelToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import collapseMenuIcon from 'app/assets/icons/sidebar/collapse-menu.svg';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import config from '../../../../config.json';
// import AdjustFontSize from '../../shared-components/AdjustFontSize';
// import FullScreenToggle from '../../shared-components/FullScreenToggle';
// import LanguageSwitcher from '../../shared-components/LanguageSwitcher';

function Divider() {
  return <div className="flex-none w-1 h-full bg-border mx-12" />;
}

// The sidebar's own collapse icon, turned to point the other way.
function OpenMenuIcon() {
  return <img className="vtwo:size-4 vtwo:rotate-180" src={collapseMenuIcon} alt="Open menu" />;
}

function ToolbarLayout1(props) {
  const fuseConfig = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const navbar = useSelector(({ fuse }) => fuse.navbar);
  const { navigationHelp } = useSelector(({ header }) => header);
  const toolbarTheme = useSelector(selectToolbarTheme);

  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="fuse-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        sx={{ backgroundColor: toolbarTheme.palette.background.paper }}
        position="static"
      >
        <Toolbar className="p-0 min-h-48 md:min-h-64">
          <div className="flex flex-1 px-16 items-center">
            {fuseConfig.navbar.display && fuseConfig.navbar.position === 'left' && (
              <>
                <Hidden lgDown>
                  {(fuseConfig.navbar.style === 'style-3' ||
                    fuseConfig.navbar.style === 'style-3-dense') && (
                    <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
                  )}

                  {fuseConfig.navbar.style === 'style-1' && !navbar.open && (
                    <NavbarToggleButton className="w-40 h-40 p-0 mx-0">
                      <OpenMenuIcon />
                    </NavbarToggleButton>
                  )}
                </Hidden>

                <Hidden lgUp>
                  <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8">
                    <OpenMenuIcon />
                  </NavbarToggleButton>
                </Hidden>
              </>
            )}

            {/* <Hidden lgDown>
              <FuseShortcuts />
            </Hidden> */}
            <NavigateBack />
          </div>

          <div className="flex items-center px-8 py-6 h-full overflow-x-auto">
            {/* <LanguageSwitcher />

            <AdjustFontSize />

            <FullScreenToggle />

            <FuseSearch />

            <QuickPanelToggleButton /> */}
            <CallSupport region={config.deploymentRegion} />

            <Divider />

            {navigationHelp && (
              <>
                <NavigationHelp />
                <Divider />
              </>
            )}

            <UserMenu />
          </div>

          {fuseConfig.navbar.display && fuseConfig.navbar.position === 'right' && (
            <>
              <Hidden lgDown>
                {!navbar.open && <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />}
              </Hidden>

              <Hidden lgUp>
                <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
              </Hidden>
            </>
          )}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default memo(ToolbarLayout1);
